import { useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';
import { DOCS_SECTION_LABELS } from './docs.types';
import {
  getRoleDocsMeta,
  groupDocsBySection,
  searchDocsForRole,
} from './docs.helpers';
import { useCurrentUserRole } from './useCurrentUserRole';
import styles from './Docs.module.scss';

export default function DocsHubPage() {
  const role = useCurrentUserRole();
  const meta = getRoleDocsMeta(role);
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const filtered = useMemo(
    () => searchDocsForRole(role, query),
    [role, query],
  );
  const groups = useMemo(() => groupDocsBySection(filtered), [filtered]);

  return (
    <div className={styles.pageContainer}>
      <div className={styles.layout}>
        <header className={styles.hero}>
          <p className={styles.eyebrow}>Centre d’aide Sphere</p>
          <h1 className={styles.title}>{meta.title}</h1>
          <p className={styles.intro}>{meta.intro}</p>
          <div className={styles.searchWrap}>
            <Search
              id="docs-search"
              labelText="Rechercher dans l’aide"
              placeholder="Rechercher un guide…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              size="md"
            />
          </div>
        </header>

        {groups.length === 0 ? (
          <p className={styles.empty}>
            Aucun guide ne correspond à « {query} » pour votre rôle.
          </p>
        ) : (
          groups.map(({ section, articles }) => (
            <section
              key={section}
              className={styles.sectionBlock}
              aria-labelledby={`docs-section-${section}`}
            >
              <div className={styles.sectionHeader}>
                <h2
                  id={`docs-section-${section}`}
                  className={styles.sectionTitle}
                >
                  {DOCS_SECTION_LABELS[section]}
                </h2>
                <span className={styles.sectionCount}>
                  {articles.length}{' '}
                  {articles.length > 1 ? 'guides' : 'guide'}
                </span>
              </div>
              <ul className={styles.articleList}>
                {articles.map((article) => (
                  <li key={article.slug}>
                    <a
                      href={`/docs/${article.slug}`}
                      className={styles.articleLink}
                      onClick={(event) => {
                        event.preventDefault();
                        navigate(`/docs/${article.slug}`);
                      }}
                    >
                      <div className={styles.articleLinkContent}>
                        <h3 className={styles.articleLinkTitle}>
                          {article.title}
                        </h3>
                        <p className={styles.articleLinkSummary}>
                          {article.summary}
                        </p>
                      </div>
                      <ArrowRight
                        size={20}
                        className={styles.articleLinkArrow}
                        aria-hidden
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          ))
        )}

        <p className={styles.footerNote}>
          Besoin d’autre chose ? Retour à l’<Link to="/">accueil</Link>.
        </p>
      </div>
    </div>
  );
}
